import * as Sentry from '@sentry/vue';
import {
  httpClientIntegration, extraErrorDataIntegration, dedupeIntegration,
} from '@sentry/integrations';

export default function initializeSentry(Vue) {
  if (process.env.NODE_ENV === 'production') {
    Sentry.init({
      Vue,
      beforeSend(event) {
        if (window.navigator.userAgent.indexOf('SznProhlizec') !== -1) {
          return null;
        }

        if (event.level && event.level !== 'error') {
          return null;
        }

        return event;
      },
      ignoreUrls: [/ads-micro\.atwebpages\.com/, /smartlook\.com/],
      ignoreErrors: ['Non-Error', 'ResizeObserver loop limit exceeded'],
      dsn: process.env.SENTRY_DSN,
      normalizeDepth: 20,
      attachStacktrace: true,
      environment: 'production',
      tracesSampleRate: 0.2,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 1.0,
      sendDefaultPii: true,
      integrations: [
        // Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: false,
          maskAllInputs: false,
          blockAllMedia: false,
        }),
        httpClientIntegration(),
        extraErrorDataIntegration(),
        dedupeIntegration(),
        Sentry.breadcrumbsIntegration(
          {
            console: true,
            dom: { serializeAttribute: ['id', 'class', 'name', 'type', 'value', 'data-analytics-id'] },
            fetch: true,
            history: true,
            xhr: true,
          },
        ),
      ],
      tracingOptions: {
        trackComponents: true,
      },
    });
  }
}
